export const shops = [
  {
    slug: "aveve",
  },
  {
    slug: "base",
  },
  {
    slug: "delhaize",
  },
  {
    slug: "gamma",
  },
  {
    slug: "hema",
  },
  {
    slug: "krefel",
  },
  {
    slug: "leen-bakker",
  },
  {
    slug: "lidl",
  },
  {
    slug: "weba",
  },
  {
    slug: "wibra",
  },
  {
    slug: "zeeman",
  },
  {
    slug: "albert-heijn",
  },
  {
    slug: "aldi",
  },
  {
    slug: "auchan-roncq",
  },
  {
    slug: "ava",
  },
  {
    slug: "belbev",
  },
  {
    slug: "bel-bo",
  },
  {
    slug: "bigmat",
  },
  {
    slug: "brico-bricoplanit",
  },
  {
    slug: "carrefour",
  },
  {
    slug: "carrefour-market",
  },
  {
    slug: "cora",
  },
  {
    slug: "dema",
  },
  {
    slug: "di",
  },
  // added as part of WEB-166
  { slug: "action" },
  { slug: "aldi" },
  { slug: "alvo" },
  { slug: "aronde" },
  { slug: "auto-5" },
  { slug: "auva" },
  { slug: "baby-dump" },
  { slug: "baby-tiener" },
  { slug: "babydump" },
  { slug: "babypark" },
  { slug: "belga-meubelen" },
  { slug: "bio-planet" },
  { slug: "boekenvoordeel" },
  { slug: "bofrost" },
  { slug: "bol-com" },
  { slug: "bon-ap" },
  { slug: "bookspot" },
  { slug: "bouwcenter-frans-vlaeminck" },
  { slug: "briko-depot" },
  { slug: "budgetmeubelen" },
  { slug: "buurtslagers" },
  { slug: "calipage" },
  { slug: "casa" },
  { slug: "centrakor" },
  { slug: "cevo" },
  { slug: "colruyt" },
  { slug: "comarkt" },
  { slug: "compudeals" },
  { slug: "coolblue" },
  { slug: "Damart" },
  { slug: "damart" },
  { slug: "de-psychologische-trucs-achter" },
  { slug: "decathlon" },
  { slug: "dreamland" },
  { slug: "e-leclerc" },
  { slug: "e5" },
  { slug: "eldi" },
  { slug: "electro-depot" },
  { slug: "electro-zschau" },
  { slug: "electrostock" },
  { slug: "euro-shop" },
  { slug: "europoint" },
  { slug: "exellent" },
  { slug: "expert" },
  { slug: "fox" },
  { slug: "freetime" },
  { slug: "fun" },
  { slug: "gero-wonen" },
  { slug: "gifi" },
  { slug: "goossens" },
  { slug: "h-m" },
  { slug: "handy-home" },
  { slug: "happyland" },
  { slug: "hartman" },
  { slug: "henders-hazel" },
  { slug: "hills-pet" },
  { slug: "holland-barrett" },
  { slug: "home-co" },
  { slug: "horta" },
  { slug: "hubo" },
  { slug: "hyper-u" },
  { slug: "ici-paris-xl" },
  { slug: "ikea" },
  { slug: "intermarche" },
  { slug: "intersport" },
  { slug: "intertoys" },
  { slug: "intratuin" },
  { slug: "itek" },
  { slug: "jbc" },
  { slug: "jeans-centre" },
  { slug: "joueclub" },
  { slug: "jouets-broze" },
  { slug: "jumbo" },
  { slug: "jysk" },
  { slug: "kamera-express" },
  { slug: "king-jouet" },
  { slug: "kruidvat" },
  { slug: "kwantum" },
  { slug: "maxi-zoo" },
  { slug: "medi-market" },
  { slug: "mediamarkt" },
  { slug: "menopro" },
  { slug: "meubelen-gaverzicht" },
  { slug: "meubelen-gova" },
  { slug: "meubelen-robbrecht" },
  { slug: "molecule" },
  { slug: "morres-meubelen" },
  { slug: "mr-bricolage" },
  { slug: "multi-bazar" },
  { slug: "nelson" },
  { slug: "netto" },
  { slug: "okay" },
  { slug: "orange" },
  { slug: "paradisio" },
  { slug: "picard" },
  { slug: "plein-be" },
  { slug: "poils-et-plumes" },
  { slug: "prenuptia" },
  { slug: "prik-tik" },
  { slug: "primark" },
  { slug: "promopromo" },
  { slug: "pronti" },
  { slug: "pronto-wonen" },
  { slug: "proximus" },
  { slug: "renmans" },
  { slug: "schuurman-schoenen" },
  { slug: "seats-and-sofas" },
  { slug: "selexion" },
  { slug: "sijben-keukens" },
  { slug: "sijben-wonen-slapen-outdoor" },
  { slug: "sleeplife" },
  { slug: "sleepworld" },
  { slug: "sligro-m" },
  { slug: "sligro" },
  { slug: "spar-be" },
  { slug: "spar-colruyt-group" },
  { slug: "spar" },
  { slug: "super-u" },
  { slug: "supra-bazar" },
  { slug: "tanger-markt" },
  { slug: "tom-co" },
  { slug: "toolspecial" },
  { slug: "toolstation" },
  { slug: "toychamp" },
  { slug: "trafic" },
  { slug: "tuinmaximaal" },
  { slug: "van-asten-babysuperstore" },
  { slug: "van-cranenbroek" },
  { slug: "vanharen-schoenen-menen" },
  { slug: "vanharen-schoenen" },
  { slug: "wijnbeurs" },
  { slug: "wooners" },
  { slug: "woonsquare" },
  { slug: "xenos" },
  { slug: "xooon" },
  { slug: "yess" },
  { slug: "ygo" },
  { slug: "zara" },
  { slug: "zelfbouwmarkt" },
] as const;

/** List of redirects that should be set for PromoPromo */
export const redirectPromoPromoPaths = new Set([
  "/nl/aldi/folder-aanbiedingen",
  "/aldi/folder-aanbiedingen",
  "/nl/delhaize/folder-aanbiedingen",
  "/nl/categorieen/warenhuis",
  "/delhaize/folder-aanbiedingen",
  "/nl/gamma/folder-aanbiedingen",
  "/nl/categorieen/wonen",
  "/nl/categorieen/drogisterij",
  "/categorieen/warenhuis",
  "/nl/albert-heijn/folder-aanbiedingen",
  "/nl/categorieen/supermarkt",
  // "/nl/winkels",
  "/nl/kruidvat/folder-aanbiedingen",
  "/gamma/folder-aanbiedingen",
  "/nl/categorieen/doe-het-zelf",
  "/categorieen/drogisterij",
  "/categorieen/wonen",
  "/winkels",
  "/nl/match-folder/ca01e494-f411-4052-ad38-d7eb218f0263/20",
  // "/nl/contact",
  "/nl/vanharen-schoenen/folder-aanbiedingen",
  // "/contact",
  "/privacy-statement",
  "/vanharen-schoenen/folder-aanbiedingen",
  "/nl/categorieen/mode",
  "/nl/privacy-statement",
  "/albert-heijn/folder-aanbiedingen",
  "/categorieen/supermarkt",
  "/nl/zakelijk-retailers",
  "/nl/cora/folder-aanbiedingen",
  "/fr/intermarche/folder-offres",
  "/nl/categorieen/baby-speelgoed",
  "/nl/categorieen/tuin-dier",
  "/nl/leen-bakker/folder-aanbiedingen",
  "/fr/entreprise-detaillants",
  "/fr/contact",
  "/nl/eldi/folder-aanbiedingen",
  "/categorieen/mode",
  "/cora/folder-aanbiedingen",
  "/fr/app",
  "/kruidvat/folder-aanbiedingen",
]);

export const redirectMyShopiPaths: Record<string, string | undefined> = {
  "/nl-be/folders": "/nl/winkels",
  "/fr-be/folders": "/fr/magasins",
  "/nl-be/wedstrijden": "/nl/aanbiedingen",
  "/nl-be/download-myshopi": "/nl/app",
  "/nl-be/cashback-kortingen": "/nl/aanbiedingen",
  "/fr-be/accueil": "/nl/nieuw",
  "/nl-be/folders/favorieten": "/nl/aanbiedingen",
  "/fr-be/folders/supermarche": "/fr/categories/supermarche",
  "/fr-be/folders/jardin-animaux": "/fr/categories/jardin-animaux",
  "/fr-be/folders/electro": "/fr/categories/electronique",
  "/fr-be/folders/beaute": "/fr/categories/droguerie",
  "/fr-be/folders/bricolage": "/fr/categories/bricolage",
  "/nl-be/folders/electro": "/nl/categorieen/elektronica",
  "/nl-be/folders/tuin-dier": "/nl/categorieen/tuin-dier",
  "/nl-be/folders/doe-het-zelf": "/nl/categorieen/doe-het-zelf",
  "/nl-be/folders/black-friday": "/nl/categorieen/black-friday",
  "/fr-be/folders/black-friday": "/fr/categories/black-friday",
  "/fr-be/folders/maison": "/fr/categories/habiter",
  "/nl-be/folders/beauty": "/nl/categorieen/drogisterij",
  "/nl-be/folders/mode": "/nl/categorieen/mode",
  "/nl-be/folders/home": "/nl/categorieen/wonen",
  "/fr-be/folders/loisirs": "/fr/categories",
  "/nl-be/folders/supermarkt": "/nl/categorieen/supermarkt",
  "/fr-be/folders/mode": "/fr/categories/fashion",
  "/stores": "/winkels",
  // Links that are used in the (legacy) app
  "/nl-be/pages/privacy": "/nl/privacyverklaring",
  "/nl-be/pages/cookies": "/nl/cookieverklaring",
  "/nl-be/pages/cgu": "/nl/gebruiksvoorwaarden",
  "/fr-be/pages/privacy": "/fr/declaration-de-confidentialite",
  "/fr-be/pages/cgu": "/fr/Conditions",
  "/fr-be/pages/cookies": "/fr/cookies",
};

export type ShopSlug = (typeof shops)[number]["slug"];
